var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiLingualInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 120,
    viewBox: "0 0 114 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.779541,
    width: 112.441,
    height: 120,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_8027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4395 93.2349C74.7974 93.2349 89.6795 78.3528 89.6795 59.9949C89.6795 41.6369 74.7974 26.7549 56.4395 26.7549C38.0815 26.7549 23.1995 41.6369 23.1995 59.9949C23.1995 78.3528 38.0815 93.2349 56.4395 93.2349Z",
    fill: "#1A1C26",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4396 34.6152C59.5196 34.6152 63.9896 44.5052 63.9896 60.0052C63.9896 75.5052 59.5196 85.3952 56.4396 85.3952C53.3596 85.3952 48.8896 75.5052 48.8896 60.0052C48.8896 44.5052 53.3596 34.6152 56.4396 34.6152ZM56.4396 32.6152C51.1696 32.6152 46.8896 44.8752 46.8896 60.0052C46.8896 75.1352 51.1596 87.3952 56.4396 87.3952C61.7196 87.3952 65.9896 75.1352 65.9896 60.0052C65.9896 44.8752 61.7196 32.6152 56.4396 32.6152Z",
    fill: "#1A1C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0396 50.8447H65.4396H47.4296H31.8396",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0396 69.1445H65.4396H47.4296H31.8396",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4394 88.0248C71.92 88.0248 84.4694 75.4754 84.4694 59.9948C84.4694 44.5143 71.92 31.9648 56.4394 31.9648C40.9589 31.9648 28.4094 44.5143 28.4094 59.9948C28.4094 75.4754 40.9589 88.0248 56.4394 88.0248Z",
    fill: "white",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3296 39.5146C39.1696 41.2246 41.2396 42.6946 43.4996 43.8746C47.3696 45.9046 51.7796 47.0446 56.4396 47.0446C61.0996 47.0446 65.5096 45.9046 69.3796 43.8746C71.6296 42.7046 73.6996 41.2246 75.5396 39.5146",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4394 80.5953C73.6094 78.8953 71.5494 77.4453 69.3194 76.2953C65.4594 74.2853 61.0894 73.1553 56.4394 73.1553C51.7894 73.1553 47.4194 74.2853 43.5594 76.2953C41.3194 77.4453 39.2594 78.9053 37.4294 80.5953",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4395 31.9746V88.0246",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4694 59.9951H28.4194",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4396 88.0248C65.1768 88.0248 72.2596 75.4754 72.2596 59.9948C72.2596 44.5143 65.1768 31.9648 56.4396 31.9648C47.7025 31.9648 40.6196 44.5143 40.6196 59.9948C40.6196 75.4754 47.7025 88.0248 56.4396 88.0248Z",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9496 69.6048H25.0296C23.2296 69.6048 21.7896 68.1648 21.7896 66.3748V42.6948C21.7896 40.9148 23.2296 39.4648 25.0296 39.4648H57.0596C58.8396 39.4648 60.2896 40.9048 60.2896 42.6948V66.3748C60.2896 68.1548 58.8496 69.6048 57.0596 69.6048H40.7596",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9496 69.6048H25.0296C23.2296 69.6048 21.7896 68.1648 21.7896 66.3748V42.6948C21.7896 40.9148 23.2296 39.4648 25.0296 39.4648H57.0596C58.8396 39.4648 60.2896 40.9048 60.2896 42.6948V66.3748C60.2896 68.1548 58.8496 69.6048 57.0596 69.6048H40.7596",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9495 69.6045V80.4145L40.7495 69.6045",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9495 69.6045V80.4145L40.7495 69.6045",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7896 58.4653L36.7096 61.3353H33.6296L39.3196 47.1553H42.5096L48.1996 61.3353H45.1196L43.9496 58.4653H37.7896ZM40.9296 50.0553L38.6196 56.0053H43.1396L40.9296 50.0553Z",
    fill: "#1A1C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9296 80.8754H87.8496C89.6496 80.8754 91.0896 79.4354 91.0896 77.6454V53.9654C91.0896 52.1854 89.6496 50.7354 87.8496 50.7354H55.8196C54.0396 50.7354 52.5896 52.1754 52.5896 53.9654V77.6454C52.5896 79.4254 54.0296 80.8754 55.8196 80.8754H72.1196",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9296 80.8754H87.8496C89.6496 80.8754 91.0896 79.4354 91.0896 77.6454V53.9654C91.0896 52.1854 89.6496 50.7354 87.8496 50.7354H55.8196C54.0396 50.7354 52.5896 52.1754 52.5896 53.9654V77.6454C52.5896 79.4254 54.0296 80.8754 55.8196 80.8754H72.1196",
    stroke: "#4230E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9296 80.875V91.675L72.1196 80.875",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9296 80.875V91.675L72.1196 80.875",
    stroke: "#4230E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9395 60.8047H64.7495V70.8047H78.9395V60.8047Z",
    fill: "white",
    stroke: "#4230E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8396 56.835V74.775",
    stroke: "#4230E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_8027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.31,
    height: 68.49,
    fill: "white",
    transform: "translate(20.7795 25.7549)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiLingualInsights);
export default __webpack_public_path__ + "static/media/multi-lingual-insights.c56f8f3380470d9f202336a7abb28734.svg";
export { ForwardRef as ReactComponent };